import React from 'react';
import { Tooltip, Typography, styled } from '@mui/material';

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: '#ffffff',
    color: '#000',
    borderRadius: 8,
    boxShadow: '0px 4px 12px rgba(0,0,0,0.15)',
    padding: theme.spacing(2),
    minWidth: 200,
    border: '1px solid #dadde9',
  },
  [`& .MuiTooltip-arrow`]: {
    color: '#ffffff',
  },
}));

const CustomTooltip = ({ children, tooltipData }) => {
  return (
    <StyledTooltip
      title={
        <>
          {Object.entries(tooltipData).map(([key, value]) =>
            value ? (
              <Typography
                key={key}
                variant="body2"
                sx={{ fontSize: 14, mb: 0.5, lineHeight: 1.5 }}>
                <strong>{key}:</strong> {value || 'Not Available'}
              </Typography>
            ) : null
          )}
        </>
      }
      arrow
      placement="top">
      <Typography
        variant="body2"
        component="span"
        sx={{
          cursor: 'pointer',
          fontWeight: 500,
          transition: 'color 0.2s ease-in-out',
          '&:hover': { color: '#007bff', textDecoration: 'none' },
        }}>
        {children}
      </Typography>
    </StyledTooltip>
  );
};

export default CustomTooltip;
